<template>
  <form>
    <slot />
  </form>
</template>

<script>
export default {
  name: "WForm",
  mounted() {
    // console.log(this.$children, this.$slots);
  },
  methods: {
    submit() {
      return this.$children.reduce((pre, ele) => {
        const isPass = ele.checkRules();
        if (pre === false) return false;
        return isPass;
      }, true);
    },
  },
};
</script>
